module.exports = __webpack_public_path__ + "static/media/flip.93792b46.svg";